/* Oliver Thomas: defer animated benefit media until needed.
   GIFs remain animated; Slick carousel controls and hover behavior stay intact. */
(function () {
  'use strict';

  function start() {
    var sections = document.querySelectorAll('.section-benefits');
    if (!sections.length) return;

    function loadImage(image) {
      if (!image) return;
      var url = image.getAttribute('data-benefit-src');
      if (!url) return;
      // A real source is assigned only when the visitor can see this image.
      image.setAttribute('loading', 'eager');
      var sources = image.getAttribute('data-benefit-srcset');
      if (sources) {
        image.setAttribute('sizes', image.getAttribute('data-benefit-sizes') || '100vw');
        image.setAttribute('srcset', sources);
      }
      image.setAttribute('src', url);
      image.removeAttribute('data-benefit-src');
      image.removeAttribute('data-benefit-srcset');
      image.removeAttribute('data-benefit-sizes');
    }

    Array.prototype.forEach.call(sections, function (section) {
      var slider = section.querySelector('.MobileSlick');
      var nearViewport = false;
      if (!slider) return;

      function loadSlideAt(index) {
        var selector = '.slick-slide[data-slick-index="' + index + '"] .benefit-image img';
        var found = slider.querySelectorAll(selector);
        Array.prototype.forEach.call(found, loadImage);
      }

      function loadVisible() {
        if (!nearViewport) return;
        if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
          var currentSlide = slider.querySelector('.slick-slide.slick-current');
          if (currentSlide) {
            var currentIndex = parseInt(currentSlide.getAttribute('data-slick-index'), 10);
            if (!isNaN(currentIndex)) {
              var total = slider.querySelectorAll('.benefit-item').length;
              // Original slides and their clones reuse the same URL / cache.
              loadSlideAt(currentIndex);
              loadSlideAt(currentIndex + 1);
              return;
            }
          }
          // Slick is initialized on window load in this legacy theme.
          var firstTwo = slider.querySelectorAll('.benefit-item');
          if (firstTwo[0]) loadImage(firstTwo[0].querySelector('.benefit-image img'));
          if (firstTwo[1]) loadImage(firstTwo[1].querySelector('.benefit-image img'));
        } else {
          var active = section.querySelector('.benefit-image.Show img');
          loadImage(active || section.querySelector('.benefit-image img'));
        }
      }

      // Benefit tab hovers and keyboard navigation must show their GIF on time.
      function loadInteracted(event) {
        var target = event.target;
        var item = target && target.closest ? target.closest('.benefit-item') : null;
        if (item && section.contains(item)) loadImage(item.querySelector('.benefit-image img'));
      }
      section.addEventListener('mouseover', loadInteracted);
      section.addEventListener('focusin', loadInteracted);
      section.addEventListener('touchstart', loadInteracted, { passive: true });

      if (window.jQuery) {
        // Slick's lazy loading does not know about the benefit's native GIF src.
        window.jQuery(slider).on('init afterChange', loadVisible);
        window.jQuery(slider).on('beforeChange', function (event, slick, current, next) {
          if (!nearViewport) return;
          loadSlideAt(next);
          if (slick && slick.slideCount) loadSlideAt((next + 1) % slick.slideCount);
        });
      }

      if ('IntersectionObserver' in window) {
        var watcher = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            nearViewport = true;
            loadVisible();
            watcher.disconnect();
          }
        }, { rootMargin: '350px 0px', threshold: 0 });
        watcher.observe(section);
      } else {
        // Browsers without IO retain the original animation functionality.
        nearViewport = true;
        Array.prototype.forEach.call(section.querySelectorAll('img[data-benefit-src]'), loadImage);
      }
      window.addEventListener('resize', loadVisible);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
